// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stripe-input {
  box-sizing: border-box;
  margin: 0;
  padding: 9.6px 11px;
  color: rgba(0, 0, 0, 0.88);
  font-size: 12px;
  line-height: 1.5714285714;
  list-style: none;
  font-family: Poppins;
  width: 100%;
  min-width: 0;
  background-color: #ffffff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  transition: all 0.2s;
}
.stripe-input:focus {
  border: 1px solid var(--primary-color);
}

.paymentDialogContainer {
  margin: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.paymentDialogContainer .paymentCheckIconContainer {
  border-radius: 50%;
  border: 3px solid #5AC99D;
  color: #5AC99D;
  width: 80px;
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
}`, "",{"version":3,"sources":["webpack://./src/component/common/with-stripe-payment/StripePayment.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,0BAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,oBAAA;AACJ;AACI;EACI,sCAAA;AACR;;AAGA;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAJ;AACI;EACI,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AACR","sourcesContent":[".stripe-input {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 9.6px 11px;\n    color: rgba(0, 0, 0, 0.88);\n    font-size: 12px;\n    line-height: 1.5714285714285714;\n    list-style: none;\n    font-family: Poppins;\n    width: 100%;\n    min-width: 0;\n    background-color: #ffffff;\n    background-image: none;\n    border: 1px solid #d9d9d9;;\n    border-radius: 6px;\n    transition: all 0.2s;\n\n    &:focus {\n        border: 1px solid var(--primary-color);\n    }\n}\n\n.paymentDialogContainer{\n    margin: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    .paymentCheckIconContainer{\n        border-radius: 50%;\n        border: 3px solid #5AC99D;\n        color: #5AC99D;\n        width: 80px;\n        aspect-ratio: 1;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 30px;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
